
// import React, { useMemo, forwardRef, useImperativeHandle, useRef } from "react";

// const UnitsSvg = forwardRef(function UnitsSvg(
//     {
//         mapWidth,
//         mapHeight,
//         clickableLayer,
//         units = [],

//         // UI
//         hoveredVilla,
//         selectedVilla,
//         onMouseEnter,
//         onMouseLeave,
//         onVillaClick,

//         // Tabs
//         activeTab,

//         // Filters
//         cancelledTypes = [],
//         cancelledAvailability = [],
//         progressCategories = [],
//         filters = {}, // { area: {min,max}, price:{min,max} }
//     },
//     ref
// ) {
//     const svgRef = useRef(null);

//     /**
//      * 🔓 Expose SAFE helper to parent
//      * parentRef.current.getCenterByCode("a-111")
//      */
//     useImperativeHandle(ref, () => ({
//         getCenterByCode(code) {
//             if (!svgRef.current || !code) return null;

//             try {
//                 const path = svgRef.current.querySelector(
//                     `#${CSS.escape(String(code).trim())}`
//                 );
//                 if (!path) return null;

//                 const bbox = path.getBBox();
//                 return {
//                     x: bbox.x + bbox.width / 2,
//                     y: bbox.y + bbox.height / 2,
//                 };
//             } catch (e) {
//                 console.error("[UnitsSvg] getCenterByCode failed", e);
//                 return null;
//             }
//         },
//     }));

//     const parsedPaths = useMemo(() => {
//         if (!clickableLayer || units.length === 0) return [];

//         const parser = new DOMParser();
//         const doc = parser.parseFromString(clickableLayer, "image/svg+xml");
//         const svgPaths = Array.from(doc.querySelectorAll("path"));

//         return svgPaths
//             .map((path) => {
//                 const id = path.id;
//                 if (!id) return null;

//                 const d = path.getAttribute("d");
//                 if (!d) return null;

//                 const unit = units.find(
//                     (u) => String(u.code ?? "").trim() === String(id).trim()
//                 );
//                 if (!unit) return null;

//                 // -----------------------------
//                 // 1️⃣ TYPE FILTER
//                 // -----------------------------
//                 const isHiddenByType =
//                     cancelledTypes.length > 0 &&
//                     cancelledTypes.includes(unit.type?.id);

//                 // -----------------------------
//                 // 2️⃣ AVAILABILITY FILTER
//                 // -----------------------------
//                 const isHiddenByAvailability =
//                     cancelledAvailability.length > 0 &&
//                     cancelledAvailability.includes(unit.availability?.id);

//                 // -----------------------------
//                 // 3️⃣ PROGRESS FILTER
//                 // -----------------------------
//                 const unitCategory = unit.progressCategory;
//                 const hasProgress = unit.progress != null;

//                 const isHiddenByCategory =
//                     progressCategories.length > 0 &&
//                     (!unitCategory || !progressCategories.includes(unitCategory));

//                 // -----------------------------
//                 // 4️⃣ RANGE FILTERS
//                 // -----------------------------
//                 const area = Number(unit.built_up_area);
//                 const price = Number(unit.actual_price);

//                 const areaMin = Array.isArray(filters?.area)
//                     ? filters.area[0]
//                     : filters?.area?.min ?? 0;

//                 const areaMax = Array.isArray(filters?.area)
//                     ? filters.area[1]
//                     : filters?.area?.max ?? Infinity;

//                 const priceMin = Array.isArray(filters?.price)
//                     ? filters.price[0]
//                     : filters?.price?.min ?? 0;

//                 const priceMax = Array.isArray(filters?.price)
//                     ? filters.price[1]
//                     : filters?.price?.max ?? Infinity;

//                 const isOutOfRange =
//                     area < areaMin ||
//                     area > areaMax ||
//                     price < priceMin ||
//                     price > priceMax;

//                 // -----------------------------
//                 // 5️⃣ FINAL HIDE LOGIC
//                 // -----------------------------
//                 const isActuallyHidden =
//                     isHiddenByType ||
//                     isHiddenByAvailability ||
//                     (hasProgress && isHiddenByCategory) ||
//                     isOutOfRange;

//                 if (isActuallyHidden) return null;

//                 // -----------------------------
//                 // 6️⃣ COLOR LOGIC
//                 // -----------------------------
//                 let fill = "#ccc";
//                 if (activeTab === "type") {
//                     fill = unit.type?.color || "#ccc";
//                 } else if (activeTab === "availability") {
//                     fill = unit.availability?.color || "#ccc";
//                 } else if (activeTab === "construction") {
//                     fill = unit.progress?.color || unit.progressColor || "#ccc";
//                 }

//                 // -----------------------------
//                 // 7️⃣ UI STATES
//                 // -----------------------------
//                 const isHovered = hoveredVilla === id;
//                 const isSelected = selectedVilla?.code === id;

//                 return (
//                     <path
//                         key={id}
//                         id={id}
//                         d={d}
//                         fill={fill}
//                         opacity={isSelected ? 0.3 : isHovered ? 0.5 : 0.85}
//                         // stroke={isSelected ? "#000" : "none"}
//                         strokeWidth={isSelected ? 3 : 1}
//                         style={{
//                             cursor: "pointer",
//                             transition: "all 0.25s ease",
//                         }}
//                         onMouseEnter={() => onMouseEnter?.(id)}
//                         onMouseLeave={onMouseLeave}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             const bbox = e.currentTarget.getBBox();
//                             onVillaClick?.({
//                                 id,
//                                 code: id,
//                                 center: {
//                                     x: bbox.x + bbox.width / 2,
//                                     y: bbox.y + bbox.height / 2,
//                                 },
//                             });
//                         }}
//                     />
//                 );
//             })
//             .filter(Boolean);
//     }, [
//         clickableLayer,
//         units,
//         hoveredVilla,
//         selectedVilla,
//         activeTab,
//         cancelledTypes,
//         cancelledAvailability,
//         progressCategories,
//         filters,
//         onMouseEnter,
//         onMouseLeave,
//         onVillaClick,
//     ]);

//     return (
//         <svg
//             ref={svgRef}
//             width={mapWidth}
//             height={mapHeight}
//             viewBox="0 0 1638.4 1638.4"
//             style={{ display: "block" }}
//             onClick={() => onVillaClick?.(null)}
//         >
//             {parsedPaths}
//         </svg>
//     );
// });

// export default UnitsSvg;

// 10/3




// import React, { useMemo, forwardRef, useImperativeHandle, useRef } from "react";
// import { useFilterContext } from "../../../context/FilterContext"; // تأكدي من مسار الـ Context

// const UnitsSvg = forwardRef(function UnitsSvg(
//     {
//         mapWidth,
//         mapHeight,
//         clickableLayer,
//         units = [],

//         // UI
//         hoveredVilla,
//         selectedVilla,
//         onMouseEnter,
//         onMouseLeave,
//         onVillaClick,

//         // Tabs
//         activeTab,

//         // Filters القادمة من الماستر بلان (الأنواع المخفية، إلخ)
//         cancelledTypes = [],
//         cancelledAvailability = [],
//         progressCategories = [],
//     },
//     ref
// ) {
//     const svgRef = useRef(null);
    
//     // 1️⃣ سحب الوحدات المفلترة جاهزة من الـ Context (تأثرت بالـ Min/Max والبحث)
//     const { filteredUnits } = useFilterContext();

//     useImperativeHandle(ref, () => ({
//         getCenterByCode(code) {
//             if (!svgRef.current || !code) return null;
//             try {
//                 const path = svgRef.current.querySelector(
//                     `#${CSS.escape(String(code).trim())}`
//                 );
//                 if (!path) return null;
//                 const bbox = path.getBBox();
//                 return {
//                     x: bbox.x + bbox.width / 2,
//                     y: bbox.y + bbox.height / 2,
//                 };
//             } catch (e) {
//                 return null;
//             }
//         },
//     }));

//     const parsedPaths = useMemo(() => {
//         if (!clickableLayer || units.length === 0) return [];

//         const parser = new DOMParser();
//         const doc = parser.parseFromString(clickableLayer, "image/svg+xml");
//         const svgElements = Array.from(doc.querySelectorAll("path, polygon, rect, circle, ellipse"));

//         return svgElements
//             .map((el) => {
//                 const id = el.id;
//                 if (!id) return null;

//                 // إيجاد الوحدة الأساسية
//                 const unit = units.find(
//                     (u) => String(u.code ?? "").trim() === String(id).trim()
//                 );
//                 if (!unit) return null;

//                 // 2️⃣ منطق الربط: هل الوحدة موجودة حالياً في نتائج الفلترة (الـ Context)؟
//                 const isFoundInContext = filteredUnits.some(fu => String(fu.id) === String(unit.id));
                
//                 // لو الوحدة تم استبعادها بالـ Min/Max أو البحث، لا ترسمها
//                 if (!isFoundInContext) return null;

//                 // 3️⃣ الفلاتر الجانبية (الأنواع، الحالات، التقدم)
//                 const isHiddenByType = cancelledTypes.length > 0 && cancelledTypes.includes(unit.type?.id);
//                 const isHiddenByAvailability = cancelledAvailability.length > 0 && cancelledAvailability.includes(unit.availability?.id);
//                 const unitCategory = unit.progressCategory;
//                 const hasProgress = unit.progress != null;
//                 const isHiddenByCategory = !progressCategories.includes(unitCategory);

//                 // الإخفاء النهائي (دمج فلاتر الماستر بلان)
//                 const isActuallyHidden = isHiddenByType || isHiddenByAvailability || (hasProgress && isHiddenByCategory);

//                 if (isActuallyHidden) return null;

//                 // --- الألوان والحالة ---
//                 let fill = "#ccc";
//                 if (activeTab === "type") fill = unit.type?.color || "#ccc";
//                 else if (activeTab === "availability") fill = unit.availability?.color || "#ccc";
//                 else if (activeTab === "construction") fill = unit.progressColor || "#ccc";

//                 const isHovered = hoveredVilla === id;
//                 const isSelected = selectedVilla?.code === id;

//                 const TagName = el.tagName.toLowerCase();

//                 const commonProps = {
//                     id: id,
//                     fill: fill,
//                     opacity: isSelected ? 0.3 : isHovered ? 0.5 : 0.85,
//                     strokeWidth: isSelected ? 3 : 1,
//                     style: { cursor: "pointer", transition: "all 0.25s ease" },
//                     onMouseEnter: () => onMouseEnter?.(id),
//                     onMouseLeave: onMouseLeave,
//                     onClick: (e) => {
//                         e.stopPropagation();
//                         const bbox = e.currentTarget.getBBox();
//                         onVillaClick?.({
//                             id,
//                             code: id,
//                             center: {
//                                 x: bbox.x + bbox.width / 2,
//                                 y: bbox.y + bbox.height / 2,
//                             },
//                         });
//                     }
//                 };

//                 // إرجاع العناصر مع الـ Keys الصحيحة
//                 if (TagName === "path") {
//                     return <path key={id} {...commonProps} d={el.getAttribute("d")} />;
//                 } else if (TagName === "polygon") {
//                     return <polygon key={id} {...commonProps} points={el.getAttribute("points")} />;
//                 } else if (TagName === "rect") {
//                     return (
//                         <rect
//                             key={id}
//                             {...commonProps}
//                             x={el.getAttribute("x")}
//                             y={el.getAttribute("y")}
//                             width={el.getAttribute("width")}
//                             height={el.getAttribute("height")}
//                         />
//                     );
//                 } else if (TagName === "circle") {
//                     return (
//                         <circle
//                             key={id}
//                             {...commonProps}
//                             cx={el.getAttribute("cx")}
//                             cy={el.getAttribute("cy")}
//                             r={el.getAttribute("r")}
//                         />
//                     );
//                 }

//                 return null;
//             })
//             .filter(Boolean);
//     }, [
//         clickableLayer, 
//         units, 
//         filteredUnits, // 🔥 ضروري جداً للتفاعل مع الـ Min/Max
//         hoveredVilla, 
//         selectedVilla, 
//         activeTab,
//         cancelledTypes, 
//         cancelledAvailability, 
//         progressCategories, 
//         onMouseEnter, 
//         onMouseLeave, 
//         onVillaClick
//     ]);

//     return (
//         <svg
//             ref={svgRef}
//             width={mapWidth}
//             height={mapHeight}
//             viewBox="0 0 1638.4 1638.4"
//             style={{ display: "block" }}
//             onClick={() => onVillaClick?.(null)}
//         >
//             {parsedPaths}
//         </svg>
//     );
// });

// export default UnitsSvg;
// import React, { useMemo, forwardRef, useImperativeHandle, useRef } from "react";
// import { useFilterContext } from "../../../context/FilterContext"; 

// const UnitsSvg = forwardRef(function UnitsSvg(
//     {
//         mapWidth,
//         mapHeight,
//         clickableLayer,
//         units = [],

//         // UI
//         hoveredVilla,
//         selectedVilla,
//         onMouseEnter,
//         onMouseLeave,
//         onVillaClick,

//         // Tabs
//         activeTab,

//         // Filters القادمة من الماستر بلان (الأنواع المخفية، إلخ)
//         cancelledTypes = [],
//         cancelledAvailability = [],
//         progressCategories = [],
//     },
//     ref
// ) {
//     const svgRef = useRef(null);
    
//     // 1️⃣ سحب الوحدات المفلترة جاهزة من الـ Context
//     // هذه الـ filteredUnits مفلترة بالفعل بالبحث، المساحة، السعر، الغرف، والحمامات.
//     const { filteredUnits } = useFilterContext();

//     useImperativeHandle(ref, () => ({
//         getCenterByCode(code) {
//             if (!svgRef.current || !code) return null;
//             try {
//                 const path = svgRef.current.querySelector(
//                     `#${CSS.escape(String(code).trim())}`
//                 );
//                 if (!path) return null;
//                 const bbox = path.getBBox();
//                 return {
//                     x: bbox.x + bbox.width / 2,
//                     y: bbox.y + bbox.height / 2,
//                 };
//             } catch (e) {
//                 return null;
//             }
//         },
//     }));

//     const parsedPaths = useMemo(() => {
//         if (!clickableLayer || units.length === 0) return [];

//         const parser = new DOMParser();
//         const doc = parser.parseFromString(clickableLayer, "image/svg+xml");
//         // دعم كل أشكال الـ SVG
//         const svgElements = Array.from(doc.querySelectorAll("path, polygon, rect, circle, ellipse"));

//         return svgElements
//             .map((el) => {
//                 const id = el.id;
//                 if (!id) return null;

//                 // إيجاد الوحدة الأساسية من قائمة الوحدات الأصلية
//                 const unit = units.find(
//                     (u) => String(u.code ?? "").trim() === String(id).trim()
//                 );
//                 if (!unit) return null;

//                 // 2️⃣ منطق الربط مع الـ Context:
//                 // هل هذه الوحدة موجودة حالياً في نتائج الفلترة (سواء بالبحث أو الـ Sliders)؟
//                 // const isFoundInContext = filteredUnits.some(fu => String(fu.id) === String(unit.id));
//                 const isFoundInContext = filteredUnits.some(
//   fu => String(fu.id) === String(unit.id)
// );
//                 // إذا لم تنجح في فلاتر الـ Context (بحث، مساحة، إلخ)، لا نرسمها
//                 if (!isFoundInContext) return null;

//                 // 3️⃣ فلاتر الماستر بلان الإضافية (Toggle Types, Status, Progress)
//                 const isHiddenByType = cancelledTypes.length > 0 && cancelledTypes.includes(unit.type?.id);
//                 const isHiddenByAvailability = cancelledAvailability.length > 0 && cancelledAvailability.includes(unit.availability?.id);
                
//                 const unitCategory = unit.progressCategory;
//                 const hasProgress = unit.progress != null;
//                 const isHiddenByCategory = !progressCategories.includes(unitCategory);

//                 // الإخفاء النهائي (دمج فلاتر الـ Context مع فلاتر الماستر بلان)
//                 const isActuallyHidden = isHiddenByType || isHiddenByAvailability || (hasProgress && isHiddenByCategory);

//                 if (isActuallyHidden) return null;

//                 // --- الألوان والحالة ---
//                 let fill = "#ccc";
//                 if (activeTab === "type") fill = unit.type?.color || "#ccc";
//                 else if (activeTab === "availability") fill = unit.availability?.color || "#ccc";
//                 else if (activeTab === "construction") fill = unit.progress?.color || unit.progressColor || "#ccc";

//                 const isHovered = hoveredVilla === id;
//                 const isSelected = selectedVilla?.code === id;
//                 const TagName = el.tagName.toLowerCase();

//                 const commonProps = {
//                     id: id,
//                     fill: fill,
//                     opacity: isSelected ? 0.3 : isHovered ? 0.5 : 0.85,
//                     strokeWidth: isSelected ? 3 : 1,
//                     style: { cursor: "pointer", transition: "all 0.25s ease" },
//                     onMouseEnter: () => onMouseEnter?.(id),
//                     onMouseLeave: onMouseLeave,
//                     onClick: (e) => {
//                         e.stopPropagation();
//                         const bbox = e.currentTarget.getBBox();
//                         onVillaClick?.({
//                             id,
//                             code: id,
//                             center: {
//                                 x: bbox.x + bbox.width / 2,
//                                 y: bbox.y + bbox.height / 2,
//                             },
//                         });
//                     }
//                 };

//                 // إرجاع العنصر المناسب مع الـ Key
//                 if (TagName === "path") {
//                     return <path key={id} {...commonProps} d={el.getAttribute("d")} />;
//                 } else if (TagName === "polygon") {
//                     return <polygon key={id} {...commonProps} points={el.getAttribute("points")} />;
//                 } else if (TagName === "rect") {
//                     return (
//                         <rect
//                             key={id}
//                             {...commonProps}
//                             x={el.getAttribute("x")}
//                             y={el.getAttribute("y")}
//                             width={el.getAttribute("width")}
//                             height={el.getAttribute("height")}
//                         />
//                     );
//                 } else if (TagName === "circle") {
//                     return (
//                         <circle
//                             key={id}
//                             {...commonProps}
//                             cx={el.getAttribute("cx")}
//                             cy={el.getAttribute("cy")}
//                             r={el.getAttribute("r")}
//                         />
//                     );
//                 }

//                 return null;
//             })
//             .filter(Boolean);
//     }, [
//         clickableLayer, 
//         units, 
//         filteredUnits, // 🔥 ضروري جداً للاستجابة اللحظية للبحث والـ Sliders
//         hoveredVilla, 
//         selectedVilla, 
//         activeTab,
//         cancelledTypes, 
//         cancelledAvailability, 
//         progressCategories, 
//         onMouseEnter, 
//         onMouseLeave, 
//         onVillaClick
//     ]);

//     return (
//         <svg
//             ref={svgRef}
//             width={mapWidth}
//             height={mapHeight}
//             viewBox="0 0 1638.4 1638.4"
//             style={{ display: "block" }}
//             onClick={() => onVillaClick?.(null)}
//         >
//             {parsedPaths}
//         </svg>
//     );
// });

// export default UnitsSvg;
// 7/4

import React, { useMemo, forwardRef, useImperativeHandle, useRef } from "react";
import { useFilterContext } from "../../../context/FilterContext"; 
import { useTabsFilter } from "../../../context/TabsFilterContext"; 

const UnitsSvg = forwardRef(function UnitsSvg(
    {
        mapWidth,
        mapHeight,
        clickableLayer,
        units = [],

        // UI
        hoveredVilla,
        selectedVilla,
        onMouseEnter,
        onMouseLeave,
        onVillaClick,

        // Tabs (قادمة من البروبس أو الكونتيكست)
        activeTab,

        // Filters القادمة من الماستر بلان
        cancelledTypes = [],
        cancelledAvailability = [],
        progressCategories = [],
    },
    ref
) {
    const svgRef = useRef(null);
    
    // 1️⃣ سحب البيانات من الـ Contexts لضمان المزامنة اللحظية
    const { filteredUnits } = useFilterContext();
    const { bookingDate } = useTabsFilter(); 

    useImperativeHandle(ref, () => ({
        getCenterByCode(code) {
            if (!svgRef.current || !code) return null;
            try {
                const path = svgRef.current.querySelector(
                    `#${CSS.escape(String(code).trim())}`
                );
                if (!path) return null;
                const bbox = path.getBBox();
                return {
                    x: bbox.x + bbox.width / 2,
                    y: bbox.y + bbox.height / 2,
                };
            } catch (e) {
                return null;
            }
        },
    }));

    const parsedPaths = useMemo(() => {
        if (!clickableLayer || units.length === 0) return [];

        const parser = new DOMParser();
        const doc = parser.parseFromString(clickableLayer, "image/svg+xml");
        const svgElements = Array.from(doc.querySelectorAll("path, polygon, rect, circle, ellipse"));

        return svgElements
            .map((el) => {
                const id = el.id;
                if (!id) return null;

                // إيجاد الوحدة الأساسية
                const unit = units.find(
                    (u) => String(u.code ?? "").trim() === String(id).trim()
                );
                if (!unit) return null;

                // 2️⃣ منطق الإخفاء والظهور بناءً على filteredUnits (التي تعالج البحث والتاريخ)
                const isFoundInContext = filteredUnits.some(
                    fu => String(fu.id) === String(unit.id)
                );
                
                if (!isFoundInContext) return null;

                // 3️⃣ فلاتر الماستر بلان الإضافية
                const isHiddenByType = cancelledTypes.length > 0 && cancelledTypes.includes(unit.type?.id);
                const isHiddenByAvailability = cancelledAvailability.length > 0 && cancelledAvailability.includes(unit.availability?.id);
                
                const unitCategory = unit.progressCategory;
                const hasProgress = unit.progress != null;
                const isHiddenByCategory = !progressCategories.includes(unitCategory);

                if (isHiddenByType || isHiddenByAvailability || (hasProgress && isHiddenByCategory)) {
                    return null;
                }

                // --- 4️⃣ منطق الألوان الذكي ---
                let fill = "#ccc";
                
                if (activeTab === "type") {
                    fill = unit.type?.color || "#ccc";
                } else if (activeTab === "availability") {
                    fill = unit.availability?.color || "#ccc";
                } else if (activeTab === "construction") {
                    fill = unit.progress?.color || unit.progressColor || "#ccc";
                } else if (activeTab === "bookingDate") {
                    // 🔥 عند تفعيل تاب الحجز، نلون الوحدات المفلترة بالأخضر
                    fill = "#28a745"; 
                }

                const isHovered = hoveredVilla === id;
                const isSelected = selectedVilla?.code === id;
                const TagName = el.tagName.toLowerCase();

                const commonProps = {
                    id: id,
                    fill: fill,
                    // تغيير الشفافية بناءً على الحالة (Selected/Hover)
                    opacity: isSelected ? 0.4 : isHovered ? 0.6 : 0.85,
                    stroke: isSelected ? "#fff" : "none",
                    strokeWidth: isSelected ? 2 : 0,
                    style: { cursor: "pointer", transition: "all 0.2s ease-in-out" },
                    onMouseEnter: () => onMouseEnter?.(id),
                    onMouseLeave: onMouseLeave,
                    onClick: (e) => {
                        e.stopPropagation();
                        const bbox = e.currentTarget.getBBox();
                        onVillaClick?.({
                            id,
                            code: id,
                            center: {
                                x: bbox.x + bbox.width / 2,
                                y: bbox.y + bbox.height / 2,
                            },
                        });
                    }
                };

                // إرجاع العناصر الرسومية حسب نوعها في الـ SVG
                if (TagName === "path") {
                    return <path key={id} {...commonProps} d={el.getAttribute("d")} />;
                } else if (TagName === "polygon") {
                    return <polygon key={id} {...commonProps} points={el.getAttribute("points")} />;
                } else if (TagName === "rect") {
                    return (
                        <rect
                            key={id}
                            {...commonProps}
                            x={el.getAttribute("x")}
                            y={el.getAttribute("y")}
                            width={el.getAttribute("width")}
                            height={el.getAttribute("height")}
                        />
                    );
                } else if (TagName === "circle") {
                    return (
                        <circle
                            key={id}
                            {...commonProps}
                            cx={el.getAttribute("cx")}
                            cy={el.getAttribute("cy")}
                            r={el.getAttribute("r")}
                        />
                    );
                }
                return null;
            })
            .filter(Boolean);
    }, [
        clickableLayer, 
        units, 
        filteredUnits, // إعادة الرسم عند تغير نتائج الفلترة
        bookingDate,   // إعادة الرسم عند تغير التاريخ
        hoveredVilla, 
        selectedVilla, 
        activeTab,
        cancelledTypes, 
        cancelledAvailability, 
        progressCategories, 
        onMouseEnter, 
        onMouseLeave, 
        onVillaClick
    ]);

    return (
        <svg
            ref={svgRef}
            width={mapWidth}
            height={mapHeight}
            viewBox="0 0 1638.4 1638.4"
            style={{ display: "block", width: "100%", height: "100%" }}
            onClick={() => onVillaClick?.(null)}
        >
            {parsedPaths}
        </svg>
    );
});

export default UnitsSvg;











// import React, { useMemo, forwardRef, useImperativeHandle, useRef } from "react";

// const UnitsSvg = forwardRef(function UnitsSvg(
//     {
//         mapWidth,
//         mapHeight,
//         clickableLayer,
//         units = [],

//         // UI
//         hoveredVilla,
//         selectedVilla,
//         onMouseEnter,
//         onMouseLeave,
//         onVillaClick,

//         // Tabs
//         activeTab,

//         // Filters
//         cancelledTypes = [],
//         cancelledAvailability = [],
//         progressCategories = [],
//         filters = {}, // { area: {min,max}, price:{min,max} }
//         // 🔥 إضافة التاريخ المختار من الـ props
//         bookingDate, 
//     },
//     ref
// ) {
//     const svgRef = useRef(null);

//     /**
//      * 🔓 Expose SAFE helper to parent
//      */
//     useImperativeHandle(ref, () => ({
//         getCenterByCode(code) {
//             if (!svgRef.current || !code) return null;

//             try {
//                 const path = svgRef.current.querySelector(
//                     `#${CSS.escape(String(code).trim())}`
//                 );
//                 if (!path) return null;

//                 const bbox = path.getBBox();
//                 return {
//                     x: bbox.x + bbox.width / 2,
//                     y: bbox.y + bbox.height / 2,
//                 };
//             } catch (e) {
//                 return null;
//             }
//         },
//     }));

//     const parsedPaths = useMemo(() => {
//         if (!clickableLayer || units.length === 0) return [];

//         const parser = new DOMParser();
//         // ✅ تصحيح النوع ليكون image/svg+xml
//         const doc = parser.parseFromString(clickableLayer, "image/svg+xml");
        
//         const svgElements = Array.from(doc.querySelectorAll("path, polygon, rect, circle, ellipse"));

//         return svgElements
//             .map((el) => {
//                 const id = el.id;
//                 if (!id) return null;

//                 const unit = units.find(
//                     (u) => String(u.code ?? "").trim() === String(id).trim()
//                 );
//                 if (!unit) return null;

//                 // --- الفلاتر (نفس المنطق بتاعك بدون تغيير) ---
//                 const isHiddenByType = cancelledTypes.length > 0 && cancelledTypes.includes(unit.type?.id);
//                 const isHiddenByAvailability = cancelledAvailability.length > 0 && cancelledAvailability.includes(unit.availability?.id);
//                 const unitCategory = unit.progressCategory;
//                 const hasProgress = unit.progress != null;
//                 const isHiddenByCategory = !progressCategories.includes(unitCategory);

//                 const area = Number(unit.built_up_area);
//                 const price = Number(unit.actual_price);
//                 const areaMin = Array.isArray(filters?.area) ? filters.area[0] : filters?.area?.min ?? 0;
//                 const areaMax = Array.isArray(filters?.area) ? filters.area[1] : filters?.area?.max ?? Infinity;
//                 const priceMin = Array.isArray(filters?.price) ? filters.price[0] : filters?.price?.min ?? 0;
//                 const priceMax = Array.isArray(filters?.price) ? filters.price[1] : filters?.price?.max ?? Infinity;

//                 // 🔥 منطق إخفاء الوحدات بناءً على التاريخ (لو الوحدة محجوزة قبل التاريخ المختار)
//                 const isHiddenByDate = activeTab === "bookingDate" && bookingDate && unit.booking_date && 
//                                        new Date(unit.booking_date) < new Date(bookingDate);

//                 const isOutOfRange = area < areaMin || area > areaMax || price < priceMin || price > priceMax;
                
//                 // إضافة isHiddenByDate للمنطق النهائي
//                 const isActuallyHidden = isHiddenByType || isHiddenByAvailability || (hasProgress && isHiddenByCategory) || isOutOfRange || isHiddenByDate;

//                 if (isActuallyHidden) return null;

//                 // --- الألوان والحالة ---
//                 let fill = "#ccc";
//                 if (activeTab === "type") fill = unit.type?.color || "#ccc";
//                 else if (activeTab === "availability") fill = unit.availability?.color || "#ccc";
//                 else if (activeTab === "construction") fill = unit.progress?.color || unit.progressColor || "#ccc";
//                 // 🔥 إضافة لون خاص بتاب تاريخ الحجز
//                 else if (activeTab === "bookingDate") fill = unit.availability?.color || "#3b82f6";

//                 const isHovered = hoveredVilla === id;
//                 const isSelected = selectedVilla?.code === id;

//                 const TagName = el.tagName.toLowerCase();
                
//                 const commonProps = {
//                     id: id,
//                     fill: fill,
//                     opacity: isSelected ? 0.3 : isHovered ? 0.5 : 0.85,
//                     strokeWidth: isSelected ? 3 : 1,
//                     style: { cursor: "pointer", transition: "all 0.25s ease" },
//                     onMouseEnter: () => onMouseEnter?.(id),
//                     onMouseLeave: onMouseLeave,
//                     onClick: (e) => {
//                         e.stopPropagation();
//                         const bbox = e.currentTarget.getBBox();
//                         onVillaClick?.({
//                             id,
//                             code: id,
//                             center: {
//                                 x: bbox.x + bbox.width / 2,
//                                 y: bbox.y + bbox.height / 2,
//                             },
//                         });
//                     }
//                 };

//                 if (TagName === "path") {
//                     return <path key={id} {...commonProps} d={el.getAttribute("d")} />;
//                 } else if (TagName === "polygon") {
//                     return <polygon key={id} {...commonProps} points={el.getAttribute("points")} />;
//                 } else if (TagName === "rect") {
//                     return (
//                         <rect
//                             key={id}
//                             {...commonProps}
//                             x={el.getAttribute("x")}
//                             y={el.getAttribute("y")}
//                             width={el.getAttribute("width")}
//                             height={el.getAttribute("height")}
//                         />
//                     );
//                 } else if (TagName === "circle") {
//                     return (
//                         <circle
//                             key={id}
//                             {...commonProps}
//                             cx={el.getAttribute("cx")}
//                             cy={el.getAttribute("cy")}
//                             r={el.getAttribute("r")}
//                         />
//                     );
//                 }

//                 return null;
//             })
//             .filter(Boolean);
//     }, [
//         clickableLayer, units, hoveredVilla, selectedVilla, activeTab,
//         cancelledTypes, cancelledAvailability, progressCategories, filters,
//         bookingDate, // 🔥 إضافة الـ dependency لضمان تحديث الـ SVG عند تغيير التاريخ
//         onMouseEnter, onMouseLeave, onVillaClick
//     ]);

//     return (
//         <svg
//             ref={svgRef}
//             width={mapWidth}
//             height={mapHeight}
//             viewBox="0 0 1638.4 1638.4"
//             style={{ display: "block" }}
//             onClick={() => onVillaClick?.(null)}
//         >
//             {parsedPaths}
//         </svg>
//     );
// });

// export default UnitsSvg;

// الفلل السيرش هنا عامل فوكس على افيلا الخاصة بالوحدة وميحذفش حاجة
// import React, { useMemo, forwardRef, useImperativeHandle, useRef } from "react";

// const UnitsSvg = forwardRef(function UnitsSvg(
//     {
//         mapWidth,
//         mapHeight,
//         clickableLayer,
//         units = [],

//         // UI
//         hoveredVilla,
//         selectedVilla,
//         onMouseEnter,
//         onMouseLeave,
//         onVillaClick,

//         // Tabs
//         activeTab,

//         // Filters
//         cancelledTypes = [],
//         cancelledAvailability = [],
//         progressCategories = [],
//         filters = {}, // { area: {min,max}, price:{min,max} }
//     },
//     ref
// ) {
//     const svgRef = useRef(null);

//     /**
//      * 🔓 Expose SAFE helper to parent
//      * parentRef.current.getCenterByCode("a-111")
//      */
//     useImperativeHandle(ref, () => ({
//         getCenterByCode(code) {
//             if (!svgRef.current || !code) return null;

//             try {
//                 const path = svgRef.current.querySelector(
//                     `#${CSS.escape(String(code).trim())}`
//                 );
//                 if (!path) return null;

//                 const bbox = path.getBBox();
//                 return {
//                     x: bbox.x + bbox.width / 2,
//                     y: bbox.y + bbox.height / 2,
//                 };
//             } catch (e) {
//                 return null;
//             }
//         },
//     }));

//     // const parsedPaths = useMemo(() => {
//     //     if (!clickableLayer || units.length === 0) return [];

//     //     const parser = new DOMParser();
//     //     const doc = parser.parseFromString(clickableLayer, "image/svg+xml");
//     //     const svgPaths = Array.from(doc.querySelectorAll("path"));

//     //     return svgPaths
//     //         .map((path) => {
//     //             const id = path.id;
//     //             if (!id) return null;

//     //             const d = path.getAttribute("d");
//     //             if (!d) return null;

//     //             const unit = units.find(
//     //                 (u) => String(u.code ?? "").trim() === String(id).trim()
//     //             );
//     //             if (!unit) return null;

//     //             // -----------------------------
//     //             // 1️⃣ TYPE FILTER
//     //             // -----------------------------
//     //             const isHiddenByType =
//     //                 cancelledTypes.length > 0 &&
//     //                 cancelledTypes.includes(unit.type?.id);

//     //             // -----------------------------
//     //             // 2️⃣ AVAILABILITY FILTER
//     //             // -----------------------------
//     //             const isHiddenByAvailability =
//     //                 cancelledAvailability.length > 0 &&
//     //                 cancelledAvailability.includes(unit.availability?.id);

//     //             // -----------------------------
//     //             // 3️⃣ PROGRESS FILTER
//     //             // -----------------------------
//     //             // -----------------------------
//     //             // 3️⃣ PROGRESS FILTER
//     //             // -----------------------------
//     //             const unitCategory = unit.progressCategory;
//     //             const hasProgress = unit.progress != null;

//     //             // التعديل هنا: 
//     //             // لو الـ progressCategories فاضية تماماً، يبقى لازم كل اللي ليهم progress يختفوا
//     //             const isHiddenByCategory = !progressCategories.includes(unitCategory);
//     //             // -----------------------------
//     //             // 4️⃣ RANGE FILTERS
//     //             // -----------------------------
//     //             const area = Number(unit.built_up_area);
//     //             const price = Number(unit.actual_price);

//     //             const areaMin = Array.isArray(filters?.area)
//     //                 ? filters.area[0]
//     //                 : filters?.area?.min ?? 0;

//     //             const areaMax = Array.isArray(filters?.area)
//     //                 ? filters.area[1]
//     //                 : filters?.area?.max ?? Infinity;

//     //             const priceMin = Array.isArray(filters?.price)
//     //                 ? filters.price[0]
//     //                 : filters?.price?.min ?? 0;

//     //             const priceMax = Array.isArray(filters?.price)
//     //                 ? filters.price[1]
//     //                 : filters?.price?.max ?? Infinity;

//     //             const isOutOfRange =
//     //                 area < areaMin ||
//     //                 area > areaMax ||
//     //                 price < priceMin ||
//     //                 price > priceMax;

//     //             // -----------------------------
//     //             // 5️⃣ FINAL HIDE LOGIC
//     //             // -----------------------------
//     //             const isActuallyHidden =
//     //                 isHiddenByType ||
//     //                 isHiddenByAvailability ||
//     //                 (hasProgress && isHiddenByCategory) ||
//     //                 isOutOfRange;

//     //             if (isActuallyHidden) return null;

//     //             // -----------------------------
//     //             // 6️⃣ COLOR LOGIC
//     //             // -----------------------------
//     //             let fill = "#ccc";
//     //             if (activeTab === "type") {
//     //                 fill = unit.type?.color || "#ccc";
//     //             } else if (activeTab === "availability") {
//     //                 fill = unit.availability?.color || "#ccc";
//     //             } else if (activeTab === "construction") {
//     //                 fill = unit.progress?.color || unit.progressColor || "#ccc";
//     //             }

//     //             // -----------------------------
//     //             // 7️⃣ UI STATES
//     //             // -----------------------------
//     //             const isHovered = hoveredVilla === id;
//     //             const isSelected = selectedVilla?.code === id;

//     //             return (
//     //                 <path
//     //                     key={id}
//     //                     id={id}
//     //                     d={d}
//     //                     fill={fill}
//     //                     opacity={isSelected ? 0.3 : isHovered ? 0.5 : 0.85}
//     //                     // stroke={isSelected ? "#000" : "none"}
//     //                     strokeWidth={isSelected ? 3 : 1}
//     //                     style={{
//     //                         cursor: "pointer",
//     //                         transition: "all 0.25s ease",
//     //                     }}
//     //                     onMouseEnter={() => onMouseEnter?.(id)}
//     //                     onMouseLeave={onMouseLeave}
//     //                     onClick={(e) => {
//     //                         e.stopPropagation();
//     //                         const bbox = e.currentTarget.getBBox();
//     //                         onVillaClick?.({
//     //                             id,
//     //                             code: id,
//     //                             center: {
//     //                                 x: bbox.x + bbox.width / 2,
//     //                                 y: bbox.y + bbox.height / 2,
//     //                             },
//     //                         });
//     //                     }}
//     //                 />
//     //             );
//     //         })
//     //         .filter(Boolean);
//     // }, [
//     //     clickableLayer,
//     //     units,
//     //     hoveredVilla,
//     //     selectedVilla,
//     //     activeTab,
//     //     cancelledTypes,
//     //     cancelledAvailability,
//     //     progressCategories,
//     //     filters,
//     //     onMouseEnter,
//     //     onMouseLeave,
//     //     onVillaClick,
//     // ]);
//     const parsedPaths = useMemo(() => {
//         if (!clickableLayer || units.length === 0) return [];

//         const parser = new DOMParser();
//         const doc = parser.parseFromString(clickableLayer, "image/svg+xml");
//         // 1️⃣ تعديل هنا: اختيار كل الأنواع الممكنة
//         const svgElements = Array.from(doc.querySelectorAll("path, polygon, rect, circle, ellipse"));

//         return svgElements
//             .map((el) => {
//                 const id = el.id;
//                 if (!id) return null;

//                 const unit = units.find(
//                     (u) => String(u.code ?? "").trim() === String(id).trim()
//                 );
//                 if (!unit) return null;

//                 // --- الفلاتر (نفس المنطق بتاعك بدون تغيير) ---
//                 const isHiddenByType = cancelledTypes.length > 0 && cancelledTypes.includes(unit.type?.id);
//                 const isHiddenByAvailability = cancelledAvailability.length > 0 && cancelledAvailability.includes(unit.availability?.id);
//                 const unitCategory = unit.progressCategory;
//                 const hasProgress = unit.progress != null;
//                 const isHiddenByCategory = !progressCategories.includes(unitCategory);

//                 const area = Number(unit.built_up_area);
//                 const price = Number(unit.actual_price);
//                 const areaMin = Array.isArray(filters?.area) ? filters.area[0] : filters?.area?.min ?? 0;
//                 const areaMax = Array.isArray(filters?.area) ? filters.area[1] : filters?.area?.max ?? Infinity;
//                 const priceMin = Array.isArray(filters?.price) ? filters.price[0] : filters?.price?.min ?? 0;
//                 const priceMax = Array.isArray(filters?.price) ? filters.price[1] : filters?.price?.max ?? Infinity;

//                 const isOutOfRange = area < areaMin || area > areaMax || price < priceMin || price > priceMax;
//                 const isActuallyHidden = isHiddenByType || isHiddenByAvailability || (hasProgress && isHiddenByCategory) || isOutOfRange;

//                 if (isActuallyHidden) return null;

//                 // --- الألوان والحالة ---
//                 let fill = "#ccc";
//                 if (activeTab === "type") fill = unit.type?.color || "#ccc";
//                 else if (activeTab === "availability") fill = unit.availability?.color || "#ccc";
//                 else if (activeTab === "construction") fill = unit.progress?.color || unit.progressColor || "#ccc";

//                 const isHovered = hoveredVilla === id;
//                 const isSelected = selectedVilla?.code === id;

//                 // 2️⃣ تحديد نوع العنصر والخصائص الجمالية
//                 const TagName = el.tagName.toLowerCase();
//                 // 1️⃣ شيلنا الـ key من هنا عشان React مش بتحبه جوه الـ spread
// const commonProps = {
//     id: id,
//     fill: fill,
//     opacity: isSelected ? 0.3 : isHovered ? 0.5 : 0.85,
//     strokeWidth: isSelected ? 3 : 1,
//     style: { cursor: "pointer", transition: "all 0.25s ease" },
//     onMouseEnter: () => onMouseEnter?.(id),
//     onMouseLeave: onMouseLeave,
//     onClick: (e) => {
//         e.stopPropagation();
//         const bbox = e.currentTarget.getBBox();
//         onVillaClick?.({
//             id,
//             code: id,
//             center: {
//                 x: bbox.x + bbox.width / 2,
//                 y: bbox.y + bbox.height / 2,
//             },
//         });
//     }
// };

// // 2️⃣ بنضيف key={id} بشكل مباشر لكل عنصر قبل الـ spread
// if (TagName === "path") {
//     return <path key={id} {...commonProps} d={el.getAttribute("d")} />;
// } else if (TagName === "polygon") {
//     return <polygon key={id} {...commonProps} points={el.getAttribute("points")} />;
// } else if (TagName === "rect") {
//     return (
//         <rect
//             key={id}
//             {...commonProps}
//             x={el.getAttribute("x")}
//             y={el.getAttribute("y")}
//             width={el.getAttribute("width")}
//             height={el.getAttribute("height")}
//         />
//     );
// } else if (TagName === "circle") {
//     return (
//         <circle
//             key={id}
//             {...commonProps}
//             cx={el.getAttribute("cx")}
//             cy={el.getAttribute("cy")}
//             r={el.getAttribute("r")}
//         />
//     );
// }
//                 // const commonProps = {
//                 //     key: id,
//                 //     id: id,
//                 //     fill: fill,
//                 //     opacity: isSelected ? 0.3 : isHovered ? 0.5 : 0.85,
//                 //     strokeWidth: isSelected ? 3 : 1,
//                 //     style: { cursor: "pointer", transition: "all 0.25s ease" },
//                 //     onMouseEnter: () => onMouseEnter?.(id),
//                 //     onMouseLeave: onMouseLeave,
//                 //     onClick: (e) => {
//                 //         e.stopPropagation();
//                 //         const bbox = e.currentTarget.getBBox();
//                 //         onVillaClick?.({
//                 //             id,
//                 //             code: id,
//                 //             center: {
//                 //                 x: bbox.x + bbox.width / 2,
//                 //                 y: bbox.y + bbox.height / 2,
//                 //             },
//                 //         });
//                 //     }
//                 // };

//                 // // 3️⃣ إرجاع العنصر المناسب بناءً على الـ Tag
//                 // if (TagName === "path") {
//                 //     return <path {...commonProps} d={el.getAttribute("d")} />;
//                 // } else if (TagName === "polygon") {
//                 //     return <polygon {...commonProps} points={el.getAttribute("points")} />;
//                 // } else if (TagName === "rect") {
//                 //     return (
//                 //         <rect
//                 //             {...commonProps}
//                 //             x={el.getAttribute("x")}
//                 //             y={el.getAttribute("y")}
//                 //             width={el.getAttribute("width")}
//                 //             height={el.getAttribute("height")}
//                 //         />
//                 //     );
//                 // } else if (TagName === "circle") {
//                 //     return (
//                 //         <circle
//                 //             {...commonProps}
//                 //             cx={el.getAttribute("cx")}
//                 //             cy={el.getAttribute("cy")}
//                 //             r={el.getAttribute("r")}
//                 //         />
//                 //     );
//                 // }

//                 return null;
//             })
//             .filter(Boolean);
//     }, [
//         clickableLayer, units, hoveredVilla, selectedVilla, activeTab,
//         cancelledTypes, cancelledAvailability, progressCategories, filters,
//         onMouseEnter, onMouseLeave, onVillaClick
//     ]);
//     return (
//         <svg
//             ref={svgRef}
//             width={mapWidth}
//             height={mapHeight}
//             viewBox="0 0 1638.4 1638.4"
//             style={{ display: "block" }}
//             onClick={() => onVillaClick?.(null)}
//         >
//             {parsedPaths}
//         </svg>
//     );
// });

// export default UnitsSvg;



